import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { UserBadgeField } from 'shared/react-admin/Fields/UserBadgeField/UserBadgeField';
import { UserAction } from 'types/embedded/userAction';

type Props = Omit<FunctionFieldProps, 'render'>;

export const UserActionUserField: React.FC<Props> = (props) => {
  return (
    <FunctionField
      render={(record: UserAction) => {
        return (
          <Box display="flex" gap={1}>
            <UserBadgeField firstName={record?.user?.firstName} lastName={record?.user?.lastName} />
            <div>
              <Typography
                gutterBottom
                variant="body2"
              >{`${record?.user?.firstName} ${record?.user?.lastName}`}</Typography>
              <Typography color="#00000061" variant="body2">
                {record?.user?.corporateEmail || record?.user?.email}
              </Typography>
            </div>
          </Box>
        );
      }}
      {...props}
    />
  );
};
